<template>
  <div class="content">
    <div id="doms" class="h-[64px] px-[20px] flex items-center justify-between"
      style="border-bottom: 1px solid #e5e5e5;">
      <div>
        <team v-if="rightpanelshow"></team>
      </div>
      <login></login>
    </div>
    <div class="content flex h-[calc(100vh-64px)]">
      <div class="leftpanel w-[300px]  h-full px-[20px] py-[20px]">
        <div class="" @click="createdesign">
          <div class="item">
            <el-icon size="16">
              <EditPen />
            </el-icon>
            <!-- <createDesign></createDesign> -->
            <div class="name">创建设计</div>
          </div>
        </div>
        <div class="" @click="jump('/home')">
          <div class="item" :class="{ 'itemactive': route.path === '/home' }">
            <el-icon size="16">
              <User />
            </el-icon>
            <div class="name">我的空间</div>
          </div>
        </div>
        <div class="" @click="jump('/home/team')">
          <div class="item" :class="{ 'itemactive': route.path === '/home/team' }">
            <el-icon size="16">
              <MessageBox />
            </el-icon>
            <div class="name">{{ '团队空间' }}</div>
          </div>
        </div>
        <!-- <div class="">
          <div class="item justify-between " @click="showTeamChild = !showTeamChild">
            <div class="flex">
              <el-icon size="16">
                <User />
              </el-icon>
              <div class="name">团队空间</div>
            </div>
            <div class="team-child-arraw" :class="{ 'team-child-show-arraw': showTeamChild }">
              <el-icon size="16">
                <ArrowRight />
              </el-icon>
            </div>

          </div>
          <div class="child" :class="{ 'team-child-show': showTeamChild }">
            <div class="item ">
              <div class="name pl-[16px]">团队1</div>
            </div>
            <div class="item">
              <div class="name pl-[16px]">团队2</div>
            </div>
          </div>
        </div>-->
      </div>
      <div class="rightpanel flex-1 h-full " v-if="rightpanelshow">
        <router-view />
      </div>
      <div class="custom-thin  rightpanel flex-1 h-full" v-else>
        <NewLoading fullscreen />
      </div>
    </div>
    <el-dialog v-model="dialogVisible" title="" width="430" top="100px" append-to-body>
      <size @create="dialogVisible = false" />
    </el-dialog>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, nextTick, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox } from 'element-plus'
import { initGlobalConfig } from '@/common/initGlobalConfig'
import { initClient } from '@/common/inituser'
import { useMiscStore } from '@/stores/misc'
import { useUserStore } from '@/stores/user'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
//@ts-ignore
import team from '@/components/topPanel/team/team.vue'
//@ts-ignore
import login from '@/components/topPanel/login/login.vue'
//@ts-ignore
import size from '@/components/fileActions/createDesign/size.vue'
const router = useRouter();
const route = useRoute()
const showTeamChild = ref(false)
const rightpanelshow = ref(false)
const userStore = useUserStore()
const currentTeam = ref<any>({})
const islogin = userStore.isLoggedIn
const dialogVisible = ref(false)

onMounted(async () => {
  await initGlobalConfig()
  await initClient()
  const miscStore = useMiscStore()
  currentTeam.value = userStore.currentTeamInfo
  if (!islogin) {
    (window as any).openGlobalLogin?.()
    return
  };
  rightpanelshow.value = true
  // // @ts-ignore
  // Auth.ins.ready((res) => {
  //   let doms = document.getElementById("doms");

  //   //@ts-ignore
  //   // Auth.user.getUserInfo({
  //   //   onSuccess: (data) => {
  //   //     //@ts-ignore
  //   //     Auth.header.init({
  //   //       insertDom: doms,
  //   //       clientId: miscStore.getClientID(),
  //   //       mask: 1,
  //   //       info: data,
  //   //       supportGroup: true,
  //   //       is_vip: false,
  //   //     });
  //   //     rightpanelshow.value = true

  //   //   },
  //   // });
  // });
});
const jump = (path: string) => {
  router.push({ path })
}
const createdesign = () => {
  dialogVisible.value = true
}
</script>
<style lang="scss" scoped>
.custom-thin {
  position: fixed;
  top: 10px;
  left: 10px;
}

.item {
  display: flex;
  cursor: pointer;
  width: 250px;
  height: 50px;
  align-items: center;
  border-radius: 10px;
  padding: 0 20px;
  box-sizing: border-box;

  .name {
    margin-left: 10px;
    font-size: 14px;
  }
}

.item:hover {
  background-color: #f5f5f5;
}

.itemactive {
  background-color: #eaf2ff;
}

.child {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.team-child-show {
  max-height: 200px;
}

.team-child-arraw {
  transform: rotate(0deg);
  transition: all 0.3s ease-in-out;
}

.team-child-show-arraw {
  transform: rotate(90deg);
  transition: all 0.3s ease-in-out;
}
</style>
